<svg
  viewBox="0 0 20 20"
  width="100%"
  height="100%"
  [ngStyle]="customStyles()"
  preserveAspectRatio="xMidYMid meet"
>
  <use [attr.href]="path()"></use>
</svg>
